module.exports = __webpack_public_path__ + "img/onboarding-icon-fork.d06347e5.svg";